// import geofencesActions from '@state/geofences/actions';
// import * as defaultAlarms from '@pages/Alertas/helpers/defaultAlerts/alertsNames';

import constants from './constants';

// const initOrCondition = {
//   type: 'numeric_threshold',
//   params: {},
// };

const setCreateEditModelsInverters = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_CREATE_EDIT_MODEL_INVERTER,
    payload: values,
  });

};

const setModelsInvertersIdEdit = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_MODEL_INVERTER_ID_TO_EDIT,
    payload: values,
  });

};

export default {
  setCreateEditModelsInverters,
  setModelsInvertersIdEdit,
};
